@if (!submitted()) {
    <h3 class="heading-2 text-primary text-center mb-8" i18n="@@contactUsHeading">Contact us</h3>
    <form #contactUsForm="ngForm" [formGroup]="form" (submit)="submit($event)">
        <div class="grid gap-4 md:grid-cols-2 mb-2">
            <div class="w-full flex flex-col">
                <input #nameControl formControlName="name" class="form-input" type="text" i18n-placeholder="@@contactNamePlaceholder" placeholder="* Name" />
                <small *ngIf="form.get('name')?.touched && form.get('name')?.invalid" class="text-red-500 -mt-2 text-sm italic" i18n="@@fieldRequiredError"
                    >Please fill out this field.</small
                >
            </div>
            <div class="w-full">
                <input formControlName="company" class="form-input" type="text" i18n-placeholder="@@contactCompanyPlaceholder" placeholder="Company" />
            </div>
        </div>

        <div class="w-full flex flex-col mb-2">
            <input formControlName="email" class="form-input" type="email" i18n-placeholder="@@contactEmailPlaceholder" placeholder="* Email" />
            <small *ngIf="form.get('email')?.touched && form.get('email')?.invalid" class="text-red-500 -mt-2 text-sm italic" i18n="@@fieldRequiredError"
                >Please fill out this field.</small
            >
        </div>

        <textarea formControlName="message" rows="4" i18n-placeholder="@@contactMessagePlaceholder" placeholder="Message" class="form-input"></textarea>
        <button
            [disabled]="!contactUsForm.touched || contactUsForm.invalid"
            class="w-full flex items-center justify-center py-2 px-4 bg-primary focus:outline-none text-white"
            type="submit"
        >
            <svg *ngIf="submitting()" class="animate-spin mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                <path
                    class="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
            </svg>

            <span i18n="@@contactSendButton">Send</span>
        </button>
    </form>
} @else {
    <h3 class="heading-2" i18n="@@contactMessageDeliveredHeading">Your Message Delivered!</h3>
    <p class="text-lg md:text-xl" i18n="@@contactMessageDeliveredText">
        Thank you for getting in touch with us. Your message is important to us, and our expert team is already on it. Expect a swift response.
    </p>
}
